import { setEnvironment } from '@backoffice-frontend/environment'
import { setLocale } from './setLocale'

export const appConfig = (): void => {
  window.setEnvironment = setEnvironment
  window.setLocale = setLocale
}
